import React, {useState} from 'react'
import {cn} from '@/lib/utils'
import {Button} from '@/components/ui/button'
import {Download} from 'hec/assets/icons'
import {BodyCopy} from '@/components/ui/body-copy'

export interface DownloadAssetButtonProps {
    asset: string
    fileName: string
    ctaText: string
    className?: string
    [key: string]: any // For ...props
}

export const DownloadAssetButton = ({
    asset,
    fileName,
    ctaText,
    className,
    ...props
}: DownloadAssetButtonProps) => {
    const [error, setError] = useState<string | null>(null)

    const handleDownload = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()

        try {
            const response = await fetch(asset)
            if (!response.ok) {
                setError('Download failed.')
            }

            const blob = await response.blob()
            const blobUrl = URL.createObjectURL(blob)

            const link = document.createElement('a')
            link.href = blobUrl
            link.download = fileName || 'download'
            document.body.appendChild(link)
            link.click()

            URL.revokeObjectURL(blobUrl)
            document.body.removeChild(link)
        } catch (error) {
            console.error('Download failed:', error)
            setError('Download failed.')
        }
    }

    return (
        <div className={cn('flex items-center', className)} {...props}>
            <button onClick={handleDownload} className="flex items-center">
                <Download className="mr-1 w-5 h-5 text-blue-04" />
                <Button
                    ctaType="link"
                    variant="normal"
                    asChild
                    className="mt-1 underline"
                    data-testid="downloadAssetButton"
                >
                    {ctaText}
                </Button>
            </button>
            {error && (
                <BodyCopy
                    className="text-error mt-1 ml-3"
                    size="small"
                    data-testid="downloadAssetButton-BodyCopy"
                >
                    {error}
                </BodyCopy>
            )}
        </div>
    )
}
